export const OperationCode = ({ original }) => { return <span>{original.operationCode}</span>};
